import React, { useEffect } from "react";
import * as BsIcons from "react-icons/bs";
import * as FiIcons from "react-icons/fi";
import * as BiIcons from "react-icons/bi";
import AOS from "aos";
import Slider from "react-slick";
import "../../styles/slick.css";
import "../../styles/slick-theme.css";
import "aos/dist/aos.css";
import "../../pages/Landing/Home.css";
import "../../data/data.json";
import data from "../../data/data.json";

const Projects = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
  };

  const PreviousBtn = (props) => {
    return (
      <div className={props.className} onClick={props.onClick}>
        <BiIcons.BiChevronLeft className="text-[#000]" />
      </div>
    );
  };

  const NextBtn = (props) => {
    return (
      <div className={props.className} onClick={props.onClick}>
        <BiIcons.BiChevronRight className="text-[#000]" />
      </div>
    );
  };

  return (
    <>
      {" "}
      <div className="section_7 pb-10 semi-md:pt-[80px]">
        <div className="mb-10">
          <h1 className="text-[30px] font-bold text-center underline">
            Projects
          </h1>
        </div>
        <Slider
          prevArrow={<PreviousBtn />}
          nextArrow={<NextBtn />}
          {...settings}
        >
          {data.projects.map((values, idx) => {
            return (
              <div key={idx} className="wrapper">
                <div className="row row-1">
                  <section className="fill content w-[100%] relative mx-auto">
                    <img
                      src={values.img}
                      alt=""
                      className="rounded-[10px] border border-[#afafaf33] w-[100%] aspect-video "
                    />
                    <div className="overlay">
                      <div className="text-center text-[30px] sm:text-[20px] text-white font-bold capitalize">
                        {values.title}
                      </div>
                      <div className="flex gap-4 items-center w-fit mx-auto mt-2.5 sm:mt-1">
                        <a href={values.url} target="_blank">
                          <div className="bg-[#0b1a26] p-1 rounded-[3px]">
                            <FiIcons.FiExternalLink className="text-[20px] text-[#0093df] " />
                          </div>
                        </a>
                        <a href={values.github} target="_blank">
                          <div className="bg-[#0b1a26] p-1 rounded-[3px]">
                            <BsIcons.BsGithub className="text-[20px] text-[#0093df]" />
                          </div>
                        </a>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            );
          })}
        </Slider>
      </div>
    </>
  );
};

export default Projects;
